<template>
    <div>
        <stripe-checkout
            ref="checkoutRef"
            :pk="getPublishableKey"
            :session-id="sessionId"
        />
        <div :class="`d-flex justify-content-${position}`">
            <el-button :loading="loading" :disabled="amount == 0"  @click="initSession" :class="amount == 0 ? '':'hover'" class="stripe-btn">
                <span>Pay with </span>
                <svg style="height: 20px; " viewBox="0 0 100 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M100 18.084C100 12.1028 96.5557 7.3832 89.9721 7.3832C83.3611 7.3832 79.361 12.1028 79.361 18.0375C79.361 25.0702 84.0833 28.6218 90.8608 28.6218C94.1666 28.6218 96.6663 27.9908 98.5555 27.1032V22.4305C96.6663 23.225 94.5 23.7155 91.7501 23.7155C89.0559 23.7155 86.6668 22.921 86.3613 20.164H99.9447C99.9447 19.86 100 18.645 100 18.0844V18.084ZM7.02772 13.7149C7.02772 12.8034 7.91647 12.4533 9.38889 12.4533C11.4999 12.4533 14.1666 12.9908 16.278 13.9484V8.45778C13.9727 7.68676 11.6947 7.3828 9.38889 7.3828C3.74988 7.3828 0 9.85938 0 13.995C0 20.4436 10.5553 19.4156 10.5553 22.1958C10.5553 23.2707 9.44423 23.6212 7.88856 23.6212C5.58272 23.6212 2.63834 22.8267 0.305072 21.7518V27.3124C2.88856 28.247 5.49947 28.6444 7.88856 28.6444C13.6662 28.6444 17.6383 26.2379 17.6383 22.0557C17.6109 15.093 7.02724 16.3311 7.02724 13.7145L7.02772 13.7149ZM25.8055 2.71012L19.028 3.92514L19.0001 22.6402C19.0001 26.0982 22.0835 28.6448 26.1948 28.6448C28.4722 28.6448 30.1391 28.2943 31.0557 27.8738V23.1307C30.167 23.4342 25.7781 24.5092 25.7781 21.0512V12.7569H31.0557V7.78025H25.7781L25.806 2.71012H25.8055ZM39.6944 9.50929L39.2498 7.78025H33.2499V28.2243H40.1944V14.3694C41.8333 12.5703 44.6112 12.8973 45.472 13.1543V7.78025C44.5833 7.49977 41.3334 6.98575 39.6944 9.50929ZM47.1668 28.2243H54.1392V7.78025H47.1668V28.2243ZM47.1668 6.00467L54.1392 4.74311V0L47.1668 1.23809V6.00427V6.00467ZM68.6392 7.3832C65.9171 7.3832 64.1671 8.45819 63.1946 9.20573L62.8337 7.75678H56.7226V35L63.6671 33.7619L63.6945 27.1497C64.6944 27.7572 66.1669 28.6218 68.6113 28.6218C73.5834 28.6218 78.1113 25.2572 78.1113 17.8509C78.0834 11.0752 73.5001 7.38361 68.6392 7.38361V7.3832ZM66.9724 23.4812C65.3335 23.4812 64.3615 22.9903 63.6945 22.3831L63.6671 13.7149C64.3894 13.0374 65.3893 12.5699 66.9724 12.5699C69.5 12.5699 71.2501 14.953 71.2501 18.0136C71.2501 21.1447 69.528 23.4812 66.9724 23.4812ZM86.278 15.8645C86.278 13.2244 88.1946 12.1259 89.9447 12.1259C91.6389 12.1259 93.4448 13.224 93.4448 15.8645H86.278Z"/>
                </svg>
            </el-button>
        </div>
    </div>
</template>

<script>
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import http from '../http'

export default {
  props:{
    amount: {
        type: Number,
        required: true
    },
    registration:{
        type: Object,
        required: true
    },
    position:{
        type:String,
        default: 'center'
    },
    success_url:{
        type: String,
        required: true
    },
    cancel_url:{
        type: String,
        required: true
    }
  },
  components: {
    StripeCheckout,
  },
  computed:{
    getEvent(){
        return this.registration.event
    },
    getPublishableKey(){
        const publishableKey = this.getEvent.stripeTestMode ?  this.getEvent.stripePublishableKeyTest : this.getEvent.stripePublishableKey
        return publishableKey;
    }
  },
  data(){
    return{
        sessionId: "",
        loading: false
    }
  },
  methods:{
    async initSession(){
        const minDeposit = this.registration.event.depositAmount 
        const { paid, total } = this.registration
        let minimum = 0
        
        if (this.registration.event.allowDeposit){
            if (total < minDeposit){
            minimum = total - paid;
            }else{
                if((minDeposit - paid ) > 0){
                    minimum = minDeposit - paid;
                }else{
                    minimum = 0;
                }
            }
        }else{
            if (this.registration.event.onlinePaymentOnly){
                minimum = total - paid;
            }
        }

        if(this.amount < minimum){
            return this.$notify({ type: 'danger', message: 'Please enter minimum amount or due amount' })
        }
        
        this.loading = true
        try {
            const res = await http.post('/api/init-stripe-session', { 
                eventId: this.registration.event._id,
                amount: this.amount,
                success_url: this.success_url,
                cancel_url: this.cancel_url,
                // success_url: window.location.href + '&success=true',
                // cancel_url: window.location.href + '&cancel=true',
                description: "Total:",
                currency: "usd",
                registration_id: this.registration._id
            })
            this.sessionId = res.data.session.id
            this.submit()
        } catch (error) {
            console.log(error);
            this.loading = false
        }
    },
    submit () {
      // You will be redirected to Stripe's secure checkout page
      this.$refs.checkoutRef.redirectToCheckout();
    },
  }
};
</script>

<style scoped>
    .stripe-btn{
        background: transparent; 
        border:1px solid gray; 
        align-items: center; 
        padding:1rem; 
        border-radius:3px; 
        margin: 12px 0;
    }
    .stripe-btn svg{
        fill: #32325D;
    }
    .stripe-btn.hover:hover{
        background: #625AFA;
        border: 1px solid #625AFA;
    }
    .stripe-btn.hover:hover span,
    .stripe-btn.hover:hover svg {
        color: #fff;
        fill: #fff;
    }
</style>